
import { makeAutoObservable, runInAction } from 'mobx'
import { storeMobx } from 'restaurant'
import { uuid } from '@dt/fe-utils'
import { StoreAPI } from '@api/index'

class App {
  constructor () {
    makeAutoObservable(this)
    if (!this.deviceId) {
      const deviceId = uuid()
      localStorage.setItem('config.deviceId', deviceId)
      runInAction(() => (this.deviceId = deviceId))
    }
    setInterval(() => {
      runInAction(() => {
        this.now = Date.now()
      })
    }, 1000)
  }

  /** 当前时间 */
  now = Date.now()

  /** 当前环境的唯一标识 */
  deviceId: string = localStorage.getItem('config.deviceId')

  // 初始化门店售卖数量
  initSaleCnt () {
    StoreAPI.getSaleCount(Config.BRANDID).then((data: any) => {
      if (data.length) {
        const storeCntMap = {}
        data.forEach(storeCnt => {
          storeCntMap[storeCnt.storeId] = storeCnt.count
        })
        storeMobx.setSaleCntMap(storeCntMap)
      }
    })
  }

  // 小程序强制跳转(不采用navigateBack返回)
  setMiniAppNoNavigateBack () {
    sessionStorage.setItem('ss.miniAppNotNavigateBack', '1')
  }
}

export default new App()
